<template>
  <div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="cancelDialog" :close-on-click-modal="false">
      <template v-if="step === 1">
        <div class="fbWrap">
          <div class="fbBlock" :class="{'active':type==1}" @click="fbClick(1)">
            <span class="fbIcon1"></span>
            <span>发布需求</span>
          </div>

          <div class="fbBlock" :class="{'active':type==2}" @click="fbClick(2)">
            <span class="fbIcon2"></span>
            <span>发布服务</span>
          </div>
        </div>
        <div class="btns">
          <div class="resetForm" @click="cancelDialog">取消</div>
          <div class="submitForm" @click="nextStep">确定</div>
        </div>
      </template>
      <template v-else>
        <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" :rules="rules" label-width="120px"
          class="demo-dynamic">
          <el-form-item prop="name" :label="getLabelName()+'名称'">
            <el-input v-model="dynamicValidateForm.name" placeholder="请输入您要发布的名称"></el-input>
          </el-form-item>
          <el-form-item prop="details" :label="getLabelName()+'详情'">
            <el-input type="textarea" :rows="3" v-model="dynamicValidateForm.details"
              :placeholder="'请输入'+getLabelName()+'详情'"></el-input>
          </el-form-item>

          <el-form-item prop="categoryId" :label="getLabelName()+'行业'">
            <el-select v-model="dynamicValidateForm.categoryId" placeholder="请选择您要发布的行业">
              <el-option :label="item.name" :value="item.id" v-for="(item, index) in list" :key="index"></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item prop="contacts" label="联系人"  :rules="[{ required: true, message: '请输入联系人姓名', trigger: 'blur' }]">
        <el-input v-model="dynamicValidateForm.contacts" readonly placeholder="请提供联系人的姓名"></el-input>
      </el-form-item>
      <el-form-item prop="phone" label="联系电话" :rules="[{ required: true, message: '请输入联系电话', trigger: 'blur' }]">
        <el-input v-model="dynamicValidateForm.phone" readonly placeholder="顾问将于1-2个工作日内给您致电"></el-input>
      </el-form-item> -->
          <el-form-item prop="budget" label="预算（元）">
            <el-input v-model="dynamicValidateForm.budget" placeholder="请输入您的预算"></el-input>
          </el-form-item>
          <!-- <el-form-item prop="enterpriseName" label="企业名称"
        :rules="[{ required: true, message: '请输入企业名称', trigger: 'blur' }]">
        <el-input v-model="dynamicValidateForm.enterpriseName" readonly placeholder="请输入您的企业名称"></el-input>
      </el-form-item> -->
          <div class="btns">
            <div class="resetForm" @click="cancelDialog">取消</div>
            <div class="submitForm" @click="submitForm('dynamicValidateForm')">立即发布</div>
            <!-- <el-button type="primary" @click="submitForm('dynamicValidateForm')">提交</el-button>
        <el-button @click="resetForm('dynamicValidateForm')">重置</el-button> -->
          </div>
        </el-form>
        <img class="sc3" src="../assets/images/sc_3@2x.png">
      </template>
    </el-dialog>
    <!--反馈弹窗-->
    <SmallDialog ref="smallDialog" tip="发布成功！" name="MyDemand"></SmallDialog>
  </div>
</template>
<script>
  import SmallDialog from './smallDialog.vue'
  import {
    publish,
    categoryList,
    fetchUserData
  } from '@/api/api'
  var isNum = (rule, value, callback) => {
    if (value) {
      const num = /^[0-9]*$/
      if (!num.test(value)) {
        callback(new Error('请输入数字'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  }
  export default {
    data() {
      return {
        title: '我要发布',
        list: [],
        dialogFormVisible: false,
        dynamicValidateForm: {
          name: '',
          details: '',
          categoryId: '',
          // contacts: '',
          // phone: '',
          budget: '',
          // enterpriseName: ''
        },
        step: 1,
        type: null,
        rules: {
          name: [{
            required: true,
            message: '请输入' + this.getLabelName() + '名称',
            trigger: 'blur'
          }],
          details: [{
            required: true,
            message: '请输入' + this.getLabelName() + '详情',
            trigger: 'blur'
          }],
          categoryId: [{
            required: true,
            message: '请选择发布' + this.getLabelName() + '行业',
            trigger: 'change'
          }],
          budget: [
            // { required: true, message: '请输入预算', trigger: 'blur' },
            {
              validator: isNum,
              trigger: 'blur'
            }
          ]
        }
      };
    },
    watch: {
      dialogData: {
        handler() {
          this.dialogFormVisible = this.dialogData
          if (this.dialogFormVisible) {
            this.getUserData()
          }
        },
        immediate: true
      }
    },
    props: ['dialogData'],
    components: {
      SmallDialog
    },
    mounted() {
      this.getCategoryList()
    },
    methods: {
      getLabelName() {
        if (this.type == 1) {
          return '需求'
        } else if (this.type == 2) {
          return '服务'
        }
        return ''
      },
      nextStep() {
        if (!this.type) {
          this.$message.error('请先选择发布项')
          return
        }
        this.step = 2
        if (this.type == 1) {
          this.title = "发布需求"
        } else if (this.type == 2) {
          this.title = "发布服务"
        }
      },
      fbClick(type) {
        this.type = type
        // this.nextStep()
      },
      isNum(rule, value, callback) {
        const num = /^[0-9]*$/
        if (!num.test(value)) {
          callback(new Error('请输入数字'))
        } else {
          callback()
        }
      },
      getUserData() {
        fetchUserData().then(res => {
          const {
            companyName,
            realname,
            nickName,
            phone
          } = res.data
          this.dynamicValidateForm.enterpriseName = companyName
          this.dynamicValidateForm.contacts = realname
          this.dynamicValidateForm.phone = phone
          if (!companyName || !realname || !phone) {
            this.$message.error('请先完善信息')
            this.goAddInfo()
          }
        })
      },
      goAddInfo() {
        this.$router.push({
          name: 'PersonalData'
        })
      },
      getCategoryList() {
        categoryList().then(res => {
          this.list = res.data
        })
      },
      cancelDialog() {
        this.type = null
        this.step = 1
        // if(this.step!== 1) {
        this.resetForm('dynamicValidateForm')
        // }
        this.$emit('valueData', false)
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              type: this.type,
              ...this.dynamicValidateForm
            }
            publish(params).then(res => {
              if (res.code === 0) {
                this.$message.error(res.msg)
              } else {
                this.$refs.smallDialog.openDialog()
                this.$refs[formName].resetFields();
                this.$emit('valueData', false)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$nextTick(()=> {
                    this.$refs[formName].resetFields();
                  })
      }
    }
  }
</script>
<style scoped>
  /deep/ .el-select {
    width: 100%;
  }

  /deep/ .el-dialog {
    width: 590px;
    height: 651px;
    background: #fff url('../assets/images/releaseDialog.png') top left no-repeat;
    background-size: 100%;
    padding-top: 30px;
    position: relative;
    border-radius: 15px;
    overflow: hidden;
  }

  .el-form-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 15px;
  }

  /deep/ .el-form-item__label {
    margin-left: 40px !important;
    width: 364px !important;
    text-align: left !important;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0A0909;
  }

  /deep/ .el-form-item__content {
    margin-left: 40px !important;
    width: 364px !important;
  }

  .submitForm {
    width: 220px;
    height: 45px;
    background: #0F5EFF;
    border-radius: 23px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 22px;
    text-align: center;
    line-height: 45px;
    margin-top: 30px;
    margin-left: 20px;
    cursor: pointer;
  }

  .resetForm {
    width: 220px;
    height: 45px;
    background: #E8EDF6;
    border-radius: 23px;
    ont-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #A7AFC3;
    line-height: 22px;
    text-align: center;
    line-height: 45px;
    margin-top: 30px;
    margin-right: 20px;
    cursor: pointer;
  }

  /deep/ .el-dialog__body {
    padding: 15px 20px
  }

  /deep/ .el-form-item__content {
    display: flex;
    justify-content: space-between;
  }

  /deep/ .el-input__inner {
    height: 45px;
  }

  /deep/ .el-dialog__header {
    width: 476px;
    margin-left: 40px;
    /* margin-bottom: 40px; */
    /* margin: 0 auto; */
  }

  /deep/ .el-dialog__title {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0A0909;
    line-height: 37px;
  }

  .sc3 {
    width: 100px;
    height: 48px;
    position: absolute;
    top: 100px;
  }

  .el-form {
    display: flex;
    flex-wrap: wrap
  }

  .btns {

    width: 100%;
    display: flex;
    justify-content: center;
  }

  .fbBlock {
    width: 200px;
    height: 260px;
    background: #F2F4FF;
    border-radius: 20px;
    border: 2px dashed #CDCFE5;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #65738A;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }

  .fbBlock:hover {
    background: rgba(15, 94, 255, 0.15);
    border: 2px dashed #0F5EFF;
    color: #0F5EFF;
  }

  .fbWrap {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    margin: 50px 0 80px;
  }

  .fbIcon1 {
    display: inline-block;
    width: 50px;
    height: 50px;
    background: url('../assets/images/icon_xq_1@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .fbIcon2 {
    display: inline-block;
    width: 50px;
    height: 50px;
    background: url('../assets/images/icon_fw_1@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .fbBlock:hover .fbIcon1 {
    background: url('../assets/images/icon_xq_2@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .fbBlock:hover .fbIcon2 {
    background: url('../assets/images/icon_fw_2@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .fbBlock.active {
    background: rgba(15, 94, 255, 0.15);
    border: 2px dashed #0F5EFF;
    color: #0F5EFF;
  }

  .fbBlock.active .fbIcon1 {
    background: url('../assets/images/icon_xq_2@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .fbBlock.active .fbIcon2 {
    background: url('../assets/images/icon_fw_2@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/PlatformDialog.vue